import {register} from "./register";
import {ExcalidrawElement, ExcalidrawTextElement} from "../element/types";
import {AppClassProperties, AppState} from "../types";
import {ToolButton} from "../components/ToolButton";
import {t} from "../i18n";
import {getShortcutKey} from "../utils";
import {getSelectedElements, isSomeElementSelected} from "../scene";
import {getNonDeletedElements, isTextElement} from "../element";
import {imgPathPerfix, isAnnoElement, isNoteElement, isStringNullOrEmpty} from "../../../../src/utils";
import {Input} from "antd";
import {changeProperty, getFormValue} from "./actionProperties";
import {getBoundTextElement} from "../element/textElement";
import {DEFAULT_ADAPTIVE_RADIUS, DEFAULT_FONT_FAMILY, DEFAULT_PROPORTIONAL_RADIUS, ROUNDNESS} from "../constants";
import {newElementWith} from "../element/mutateElement";
import {getCornerRadius} from "../math";
import {hasCorner, hasStrokeColor} from "../scene/comparisons";
import {KEYS} from "../keys";
import {useState} from "react";
import {KEY_CARD_ELEMENT_DEFAULT_STYLE} from "../../../../src/Const";

let mInputValue = 0

export const actionAngleCorner = register({
    name:'angleCorner',
    trackEvent:{category:'element'},
    perform:(elements, appState, value, app) => {
        return {
            elements: changeProperty(
                elements,
                appState, (el:any) => {
                    if (isNoteElement(el)){
                        return el;
                    }
                    if (value.corner){
                        let jsonConfig:any = localStorage.getItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
                        if (jsonConfig){
                            jsonConfig = JSON.parse(jsonConfig);
                        }else{
                            jsonConfig = {};
                        }
                        jsonConfig.corner = value.corner;
                        localStorage.setItem(KEY_CARD_ELEMENT_DEFAULT_STYLE,JSON.stringify(jsonConfig));
                    }

                    return newElementWith(el, value)
                },
                value.hasOwnProperty('angle'),
            ),
            appState: {
                ...appState,
                ...value,
            },
            commitToHistory: true,
        };
        // return{
        //     ...fixSizeElement(elements,appState,formData,app),
        //     commitToHistory:true
        // }
    },
    contextItemLabel:"",
    PanelComponent:({elements,appState,updateData,app})=>{
        const [angle,setAngle] = useState(getFormValue(
            elements,
            appState,
            (element) => {
                if (element.extra?.tempAngle != undefined){
                    return (element.extra?.tempAngle);
                }

                let angle = Math.floor(element.angle/Math.PI * 180);
                if (angle > 180){
                    angle = - (360-angle);
                }
                return angle+"";
            },
            (element) =>
                true,
            (hasSelection) =>
                0,
        ));
        const [corner,setCorner] = useState(getFormValue(
            elements,
            appState,
            (element) => {
                // let corner = 0;
                // if(element.roundness?.type === ROUNDNESS.ADAPTIVE_RADIUS){
                //     corner = element.roundness.value || 0;
                // }
                if (element.extra?.tempRoundness != undefined){
                    return (element.extra?.tempRoundness);
                }

                const radius = getCornerRadius(
                    Math.min(element.width, element.height),
                    element,
                );
                return Math.floor(radius);
            },
            (element) =>
                true,
            (hasSelection) =>
                0,
        ));

        return(
            <fieldset>
                <div style={{display:'flex',alignItems:'center'}}>
                    <img className='img-mini-small-8' style={{height:'18px',width:'18px',marginLeft:'-3px',marginBottom:'3px'}} src={imgPathPerfix()+"attr_angle.png"}/>
                    <div style={{display:'flex',position:'relative'}}>
                        <div className='flex-center' style={{position:"absolute",marginLeft:'10px',top:'6px',pointerEvents:'none'}}>
                        <span style={{visibility:'hidden'}}>{angle}</span>
                            <span style={{marginTop:'-16px'}}>°</span>
                        </div>

                        <input
                            className='default-font-size'
                            style={{height:'26px',width:'86px',border:'0px solid var(--input-border-color)',background:'transparent',
                                borderRadius:'3px',paddingLeft:'4px',marginLeft:'2px'}}  value={angle}
                            onChange={(e)=>{
                                // if (!isNumber(e.currentTarget.value.replace("°","")))return;
                                // var newValue = parseInt(e.currentTarget.value);
                                // if (isNaN(newValue)){
                                //     newValue = 0;
                                // }
                                // //转成弧度
                                // updateData({angle:newValue/180*Math.PI});

                                if (!isNumber(e.currentTarget.value) && !isStringNullOrEmpty(e.currentTarget.value))return;
                                var newValue:any = parseInt(e.currentTarget.value);
                                if (isNaN(newValue)){
                                    newValue = 0;
                                }
                                mInputValue = newValue;
                                if (e.currentTarget.value == '-'){
                                    newValue = '-';
                                }
                                if (isStringNullOrEmpty(e.currentTarget.value)){
                                    newValue = '';
                                }
                                setAngle(newValue);
                                updateData({extra:{tempAngle:newValue}});
                            }}
                            onFocus={(event => {
                                mInputValue = parseInt(event.currentTarget.value)
                                event.currentTarget.select();
                                app.onPointDownEvent((activeTool,pointerDownState)=>{
                                    updateData({angle:mInputValue/180*Math.PI,extra:{}});
                                    app.onPointDownEvent(null);
                                });
                            })}
                            onBlur={(event => {
                                updateData({angle:mInputValue/180*Math.PI,extra:{}});
                            })}
                            onKeyDown={(event => {
                                if (event.key === KEYS.ENTER){
                                    const arraySelectedElements = getSelectedElements(elements, appState, {
                                        includeBoundTextElement: false,
                                    })

                                    if (arraySelectedElements.length == 1 && isNoteElement(arraySelectedElements[0])){
                                        event.currentTarget.value = '0';
                                        mInputValue = 0;
                                    }

                                    if (!isNumber(event.currentTarget.value)){
                                        updateData({extra:{}})
                                    }else{
                                        updateData({angle:mInputValue/180*Math.PI});
                                    }
                                    event.currentTarget.blur();
                                }
                            })}
                        />
                    </div>

                    {
                        (getFormValue(
                            elements,
                            appState,
                            (element) => {
                                return hasCorner(element.type)
                            },
                            (element) =>
                                true,
                            (hasSelection) =>
                                false,
                        )) &&
                        <>
                            <img className='img-mini-small-8 ml-4' style={{height:'8px',width:'8px'}} src={imgPathPerfix()+"attr_corner.png"}/>
                            <input style={{height:'26px',width:'64px',border:'0px solid var(--input-border-color)',background:'transparent', borderRadius:'3px',paddingLeft:'4px',marginLeft:'4px'}} value={corner}
                                   onChange={(e)=>{
                                       // var newValue = parseInt(e.currentTarget.value);
                                       // if (isNaN(newValue) || isStringNullOrEmpty(e.currentTarget.value)){
                                       //     newValue = 0;
                                       // }
                                       // updateData({roundness:{type:ROUNDNESS.ADAPTIVE_RADIUS,value:newValue}});
                                       if (!isNumber(e.currentTarget.value) && !isStringNullOrEmpty(e.currentTarget.value))return;
                                       var newValue:any = parseInt(e.currentTarget.value);
                                       if (isNaN(newValue)){
                                           newValue = 0;
                                       }
                                       mInputValue = newValue;
                                       if (isStringNullOrEmpty(e.currentTarget.value)){
                                           newValue = '';
                                       }
                                       setCorner(newValue);
                                       updateData({extra:{tempRoundness:newValue}});
                                   }}
                                   onFocus={(event => {
                                       mInputValue = parseInt(event.currentTarget.value)
                                       event.currentTarget.select();
                                       app.onPointDownEvent((activeTool,pointerDownState)=>{
                                           updateData({roundness:{type:ROUNDNESS.ADAPTIVE_RADIUS,value:mInputValue},extra:{}});
                                           app.onPointDownEvent(null);
                                       });
                                   })}
                                   onBlur={(event => {
                                       updateData({roundness:{type:ROUNDNESS.ADAPTIVE_RADIUS,value:mInputValue},extra:{}});
                                   })}
                                   onKeyDown={(event => {
                                       if (event.key === KEYS.ENTER){

                                           if (!isNumber(event.currentTarget.value)){
                                               updateData({extra:{}})
                                           }else{
                                               updateData({roundness:{type:ROUNDNESS.ADAPTIVE_RADIUS,value:parseInt(event.currentTarget.value)}});
                                           }
                                           event.currentTarget.blur();
                                       }
                                   })}
                            />
                        </>
                    }

                </div>
            </fieldset>
        )
    }
})

const isNumber = (inputStr)=>{
    const reg = /^-?\d*(\.\d*)?$/;
    return (reg.test(inputStr));
}

const fixSizeElement = (
    elements:readonly ExcalidrawElement[],
    appState:AppState,
    formData,
    app:AppClassProperties
) => {
    var arrayNewElements = [...elements];
    for (var i=0;i<arrayNewElements.length;i++){
        var element = arrayNewElements[i];
        if (appState.selectedElementIds[element.id]) {
            arrayNewElements.splice(i,1);
            let newElement: ExcalidrawTextElement = newElementWith(element, {
                ...formData
            });
            return {
                elements:[...arrayNewElements,newElement],
                appState: {
                    ...appState
                }
            };
            break;
        }
    }
}























